import { z } from "zod";

/** Stable codes for the API and clients; the messages are for logs and are not translated. */
export const TIER_LIMIT_CODES = {
  team: "tier_team_limit",
  private: "tier_private_limit",
  mixedGroup: "tier_mixed_group",
} as const;

export type TierLimitCode = (typeof TIER_LIMIT_CODES)[keyof typeof TIER_LIMIT_CODES];

/** The `data` of an API refusal for a plan limit. `limit` is absent for a mixed group. */
export const TierLimitDataSchema = z.object({
  code: z.enum([TIER_LIMIT_CODES.team, TIER_LIMIT_CODES.private, TIER_LIMIT_CODES.mixedGroup]),
  tier: z.string(),
  limit: z.number().int().nonnegative().optional(),
});
export type TierLimitData = z.infer<typeof TierLimitDataSchema>;

/** The plan-limit details an RPC error carries, or null when the error is not a plan refusal. */
export function tierLimitData(error: unknown): TierLimitData | null {
  if (!error || typeof error !== "object" || !("data" in error)) return null;
  const parsed = TierLimitDataSchema.safeParse(error.data);
  return parsed.success ? parsed.data : null;
}
